var Backbone = require('backbone/backbone');
var _ = require('underscore/underscore');
require('owl.carousel/dist/assets/owl.carousel.css');
require('owl.carousel');
var Utils = require('front/utils/Utils');
require('jquery.dotdotdot');

require('front/components/CommentCount/CommentCount');
require('front/components/Category/Category');
var VideoRecentItem = require('front/components/VideoRecentItem/VideoRecentItem');
require('./VideoRecent.less');

var CheckDevice = require('front/utils/CheckDevice/CheckDevice');

module.exports = Backbone.View.extend({
    el: '.VideoRecent',

    events: {
        'mouseenter .VideoRecentItem .VideoRecentItem-title': 'hoverOn',
        'mouseleave .VideoRecentItem .VideoRecentItem-title': 'hoverOff'
    },

    initialize: function (options) {
        this.initTitles();

        this.views = this.$('.VideoRecentItem').map(function (index, el) {
            return new VideoRecentItem({
                el: $(el)
            });
        });

        this.initSlider();

        app.vent.on('Popup-startOpening', this.handleVisibilityChange.bind(this));
        document.addEventListener('visibilitychange', this.handleVisibilityChange.bind(this), false);
        app.els.$window.on('scroll resize', _.throttle(this.checkVisibility.bind(this), 50));
    },

    initSlider: function () {
        this.$list = this.$('.VideoRecent-list');

        this.$list.owlCarousel({
            items: 1,
            mouseDrag: false,
            loop: true,
            nav: true,
            navSpeed: 700,
            dots: false,
            slideBy: 'page',
            autoplay: false,
            dragEndSpeed: 800
        });

        //Get active item
        for (var i = 0; i < this.views.size(); i++) {
            if (this.views[i].$el.closest('.owl-item').hasClass('active')) {
                this.pageIndex = i;
                this.views[i].initPlayer();
                break;
            }
        }

        this.$list.on('translated.owl.carousel', function (e) {
            this.views[this.pageIndex].trigger('VideoRecentItem-leave');
            this.pageIndex = e.page.index;

            var newSlideView = this.views[this.pageIndex];
            if (!newSlideView.playerInitialized) {
                newSlideView.initPlayer();
            }
        }.bind(this));
    },

    checkVisibility: function () {
        if (this.views[this.pageIndex].playerPlaying && !Utils.isElementInViewport(this.$list)) {
            this.views[this.pageIndex].stopVideo();
        }
    },

    handleVisibilityChange: function () {
        this.views[this.pageIndex].stopVideo();
    },

    initTitles: function () {
        this.$('.VideoRecentItem-title').dotdotdot();
    },

    hoverOn: function (e) {
        var $item = $(e.target).closest('.VideoRecentItem');
        $item.addClass('VideoRecentItem--hover');
    },

    hoverOff: function (e) {
        var $item = $(e.target).closest('.VideoRecentItem');
        $item.removeClass('VideoRecentItem--hover');
    }
});




//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/VideoRecent/VideoRecent.js
// module id = 177
// module chunks = 0